import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Marcin Ostrowski - Ortopeda',
			metaTags: [
				{
					name: 'description',
					content: 'Prywatny gabinet ortopedyczny Marcina Ostrowskiego'
				},
				{
					name: 'keywords',
					content: 'badanie bioderek, usg bioderek, usg stawów biodrowych, badanie niemowląt, na bioderka,noworotków, niemowląt'
				},
				{
					property: 'og:description',
					content: 'badanie bioderek,usg bioderek,usg stawów biodrowych, badanie niemowląt, na bioderka, noworotków, niemowląt'
				}
			]
		},
	},
	{
		path: '/o-mnie',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			title: 'Marcin Ostrowski - Ortopeda | O mnie',
			metaTags: [
				{
					name: 'description',
					content: 'Lekarz, ortopeda, dziecięcy, niemowłat, noworotków, specjalista chirurgii, ortopedyczno, urazowej. Prywatny gabinet ortopedyczny Marcina Ostrowskiego'
				},
				{
					name: 'keywords',
					content: 'Lekarz, ortopeda, dziecięcy, niemowłat, noworotków, specjalista chirurgii, ortopedyczno, urazowej'
				},
				{
					property: 'og:description',
					content: 'Lekarz, specjalista chirurgii ortopedyczno-urazowej w Szpitalu Klinicznym im. A. Grucy w Otwocku'
				}
			]
		},
	},
	{
		path: '/diagnostyka-i-leczenie',
		name: 'Projects',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
		meta: {
			title: 'Marcin Ostrowski - Ortopeda | Diagnostyka i leczenie',
			metaTags: [
				{
					name: 'description',
					content: 'Badanie bioderek, usg bioderek, usg stawów biodrowych, badanie niemowląt, na bioderka,noworotków, niemowląt. Prywatny gabinet ortopedyczny Marcina Ostrowskiego'
				},
				{
					name: 'keywords',
					content: 'badanie bioderek, usg bioderek, usg stawów biodrowych, badanie niemowląt, na bioderka,noworotków, niemowląt'
				},
				{
					property: 'og:description',
					content: 'badanie bioderek,usg bioderek,usg stawów biodrowych, badanie niemowląt, na bioderka, noworotków, niemowląt'
				}
			]
		},
	},
	{
		path: '/zabiegi',
		name: 'Projects1',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Projects1.vue'),
		meta: {
			title: 'Marcin Ostrowski - Ortopeda',
			metaTags: [
				{
					name: 'description',
					content: 'Osocze bogatopłytkowe, PRP, zastrzyki do stawu, blokada. Prywatny gabinet ortopedyczny Marcina Ostrowskiego'
				},
				{
					name: 'keywords',
					content: 'osocze bogatopłytkowe, PRP, zastrzyki do stawu, blokada'
				},
				{
					property: 'og:description',
					content: 'osocze bogatopłytkowe, PRP, zastrzyki do stawu, blokada'
				}
			]
		},
	},
	{
		path: '/projects/single-project',
		name: 'Single Project',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/SingleProject.vue'
			),
		meta: {
			title: 'Marcin Ostrowski - Ortopeda',
		},
	},
	{
		path: '/kontakt',
		name: 'Contact',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Contact.vue'),
		meta: {
			title: 'Marcin Ostrowski - Ortopeda | Kontakt',
			metaTags: [
				{
					name: 'description',
					content: 'Prywatny gabinet ortopedyczny Marcina Ostrowskiego. Pl. Kilińskiego 4/5, 05-300 Mińsk Mazowiecki. Kontakt: 606 379 728'
				},
				{
					name: 'keywords',
					content: 'badanie bioderek, usg bioderek, ortopeda dziecięcy, niemowlęta'
				},
				{
					property: 'og:description',
					content: 'badanie bioderek, usg bioderek, ortopeda dziecięcy, niemowlęta'
				}
			]
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

/**
 * Below code will display the component/active page title
 * Powered by: Nangialai Stoman
 */

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
